import { Menu, MenuItem, PageSidenav } from '@pypestream/design-system';
import {
  TranslationComponent,
  type TranslationKeys,
} from '@pypestream/translations';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useProStudioCtxSelector } from '../../xstate/app.xstate';
import { PROJECT_SETTINGS_SECTIONS } from './sections';

/**
 * Left side-nav for the project-level area (Solutions list + Project Settings
 * sections). Replaces the old centered top tabs — it renders on both the
 * Solutions/home page and every settings page, so the two share one nav.
 */
export const ProjectAreaSidenav: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const projectId = useProStudioCtxSelector((ctx) => ctx.project?.id);

  // No project selected yet (project-selection screen) — nothing to scope to.
  if (!projectId) {
    return null;
  }

  const homePath = `/${projectId}`;
  const settingsBase = `${homePath}/settings`;

  return (
    <PageSidenav test-id="ps-project-area-sidenav">
      <Menu>
        <MenuItem
          variant="filled"
          value="solutions"
          selected={pathname === homePath}
          onClick={() => navigate(homePath)}
          test-id="ps-project-area-nav-solutions"
        >
          <TranslationComponent i18nKey="pro-studio/navigation:nav_links.solutions">
            Solutions
          </TranslationComponent>
        </MenuItem>
        {PROJECT_SETTINGS_SECTIONS.map(({ value, i18nKey, label }) => (
          <MenuItem
            key={value}
            variant="filled"
            value={value}
            selected={pathname === `${settingsBase}/${value}`}
            onClick={() => navigate(`${settingsBase}/${value}`)}
            test-id={`ps-project-area-nav-${value}`}
          >
            <TranslationComponent i18nKey={i18nKey as TranslationKeys}>
              {label}
            </TranslationComponent>
          </MenuItem>
        ))}
      </Menu>
    </PageSidenav>
  );
};
